<template>
  <div class="win">
    <win-page/>
  </div>
</template>

<script>
// @ is an alias to /src
import winPage from '@/components/winPage.vue'
export default {
  name: 'win',
  components: {
    winPage
  }
}
</script>
